import { interopDefault } from '~/router/utils'

export default [
  {
    name: '__login',
    path: '/login/',
    component: () =>
      interopDefault(
        import(
          '~/pages/auth/login.vue' /* webpackChunkName: "pages-auth-login.vue" */
        )
      ),
    meta: { showOneTap: true }
  },
  {
    name: '__guest_register',
    path: '/guests/register/',
    component: () =>
      interopDefault(
        import(
          '~/pages/auth/guest-register.vue' /* webpackChunkName: "pages-auth-guest-register.vue" */
        )
      ),
    meta: { showOneTap: true }
  },
  {
    name: '__password_reset',
    path: '/password-reset/',
    component: () =>
      interopDefault(
        import(
          '~/pages/auth/password-reset.vue' /* webpackChunkName: "pages-auth-guest-password-reset.vue" */
        )
      )
  },
  {
    name: '__password_set',
    path: '/password-set/',
    component: () =>
      interopDefault(
        import(
          '~/pages/auth/password-set.vue' /* webpackChunkName: "pages-auth-guest-password-set.vue" */
        )
      )
  },
  {
    name: '__logout',
    path: '/logout/',
    component: () =>
      interopDefault(
        import(
          '~/pages/auth/logout.vue' /* webpackChunkName: "pages-auth-logout.vue" */
        )
      )
  },
  {
    name: '__logged_out',
    path: '/logged-out/',
    component: () =>
      interopDefault(
        import(
          '~/pages/auth/logged-out.vue' /* webpackChunkName: "pages-auth-logged-out.vue" */
        )
      )
  },
  {
    name: '__google_signin_redirect',
    path: '/google-login/',
    component: () =>
      interopDefault(
        import(
          '~/pages/auth/google-login-redirect.vue' /* webpackChunkName: "pages-auth-google-login-redirect.vue" */
        )
      ),
    meta: { noFooter: true, noHeader: true }
  },
  {
    name: '__guest_register_activate',
    path: '/guests/register/activate/',
    component: () =>
      interopDefault(
        import(
          '~/pages/auth/guest-register-activate.vue' /* webpackChunkName: "pages-auth-guest-register-activate.vue" */
        )
      ),
    meta: { noFooter: true, noHeader: true }
  },
  {
    path: '/email-change-activation/',
    name: '__email_change_activation',
    component: () =>
      interopDefault(
        import(
          '~/pages/auth/email-change-activation.vue' /* webpackChunkName: "pages-auth-email-change-activation.vue" */
        )
      ),
    meta: { noFooter: true, noHeader: true }
  }
]
